"use client";

import { useEffect, useState } from 'react';
import Script from 'next/script';
import { hasAdsConsent } from '@/components/common/CookieBanner';

declare global {
  interface Window {
    ezstandalone: any;
  }
}

export default function EzoicLoader() {
    const [allow, setAllow] = useState(false);

    useEffect(() => {
        const update = () => setAllow(hasAdsConsent());
        update();
        window.addEventListener('consentchange', update);
        return () => window.removeEventListener('consentchange', update);
    }, []);

    if (!allow) return null;

    return (
        <>
            {/* 1. Ezoic Privacy/Consent Scripts (Required for GDPR/CCPA) */}
            <Script
                id="ezoic-gatekeeper-1"
                src="https://cmp.gatekeeperconsent.com/min.js"
                strategy="afterInteractive"
                data-cfasync="false"
            />
            <Script
                id="ezoic-gatekeeper-2"
                src="https://the.gatekeeperconsent.com/cmp.min.js"
                strategy="afterInteractive"
                data-cfasync="false"
            />

            {/* 2. Ezoic Main Loader Script */}
            <Script
                id="ezoic-loader"
                src="//www.ezojs.com/ezoic/sa.min.js"
                strategy="afterInteractive"
                async
            />

            {/* 3. Ezoic Initialization Snippet */}
            <Script id="ezoic-init" strategy="afterInteractive">
                {`
                    window.ezstandalone = window.ezstandalone || {};
                    ezstandalone.cmd = ezstandalone.cmd || [];
                `}
            </Script>
        </>
    );
}
